export enum KnownApexClassStatus {
	Active = 1,
	Inactive,
	Deleted
}
